<template>
  <div class="commentBox">
    <div class="top">评论（{{ detailData.commentCount }}）</div>
    <div class="commentItem">
      <commentItem v-for="item in messageList" :key="item.commentId" :item="item">
        <template #default="{ commentList }">
          <commentItem
            v-for="itm in listRender(commentList,item)"
            :key="itm.commentId"
            :item="itm"
          ></commentItem>
          <div class="reply" v-if="showTarget(commentList,item)" @click="onShowTargetList(item)">
            <div class="solid"></div>
            <div class="right">
              <div class="text">查看 {{ commentList.length - 1 }} 条回复</div>
              <i class="el-icon-arrow-down"></i>
            </div>
          </div>
          <div class="reply" v-if="hideTarget(commentList,item)" @click="onHideTargetList(item)">
            <div class="solid"></div>
            <div class="right">
              <div class="text">点击收起</div>
              <i class="el-icon-arrow-up"></i>
            </div>
          </div>
        </template>
      </commentItem>
      <empty description="暂无评论" v-if="messageList.length === 0"/>
    </div>
  </div>
</template>

<script>
import commentItem from "./commentItem.vue";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    commentItem,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState("information", ["messageList", "detailData", "showTargetList"]),
  },
  methods: {
    ...mapMutations("information", ["setShowTargetList"]),
    listRender(list,item) {
      if (list.length === 0) {
        return [];
      }
      if (list.length === 1) {
        return list;
      }
      if(this.showTargetList.includes(item.commentId)){
        return list
      }
      return list.slice(0, 1);
    },
    //  显示是否显示查看更多  
    showTarget(list,item) {
      if (list.length <= 1) {
        return false;
      }
      console.log("item.commentId",item)
      if(this.showTargetList.includes(item.commentId)){
        return false;
      }
      return true;
    },
    hideTarget(list,item) {
      if (list.length <= 1) {
        return false;
      }
      if(this.showTargetList.includes(item.commentId)){
        return true;
      }
      return false;
    },
    onShowTargetList(item) {
      this.setShowTargetList([item.commentId]);
    },
    onHideTargetList(item) {
      this.setShowTargetList([]);
    }
  },
};
</script>

<style scoped lang="scss">
@import "./index.scss";
.commentBox {
  flex: 1;
  .top {
    height: 56px;
    padding: 0 30px;
    display: flex;
    align-items: center;
    color: #262626;
    font-size: 14px;
    font-weight: 500;
    line-height: normal;
  }

  .commentItem {
    padding: 0 30px;
    // padding-bottom: $messageBoxHeight;
    .reply {
      margin-top: -16px;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      gap: 10px;
      .solid {
        width: 30px;
        height: 1px;
        background: #cccccc;
      }
      .right {
        display: flex;
        gap: 6px;
        font-size: 14px;
        letter-spacing: 0em;
        color: #999999;
        cursor: pointer;
        &:hover {
          color: #0062ff;
        }
      }
    }
  }
}
</style>
